import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  AppHeaderBrand,
  AppHeaderDivider,
  AppHeaderEnd,
  AppHeaderStart
} from "@/zapi-frontend/widgets/Header/ui/blocks/AppHeader";
import { useCaseBriefChatStore } from "@/zapi-frontend/stores/caseBriefChatStore";
import { getRouteProjects } from "@/zapi-frontend/shared/const/router";
import { AccountBar } from "./_AccountBar";
import { ProjectBreadcrumb } from "./_ProjectBreadcrumb";

const resetDraft = () => useCaseBriefChatStore.getState().reset();

export function NewProjectHeader() {
  const { t } = useTranslation(["createProject", "projectHome"]);
  const projectName = useCaseBriefChatStore((s) => s.projectName);
  const iconShape = useCaseBriefChatStore((s) => s.iconShape);
  const iconColor = useCaseBriefChatStore((s) => s.iconColor);
  const logoUrl = useCaseBriefChatStore((s) => s.logoUrl);

  return (
    <>
      <AppHeaderStart className="gap-2 sm:gap-3">
        <AppHeaderBrand
          render={<Link to={getRouteProjects()} onClick={resetDraft} data-testid="header-logo-link" />}
          aria-label={t("projectHome:header.brandLabel")}
          className="hidden sm:flex"
        />
        <AppHeaderDivider className="hidden sm:block" />
        <ProjectBreadcrumb
          name={projectName || t("newProject.untitled")}
          iconShape={iconShape}
          iconColor={iconColor}
          logoUrl={logoUrl}
          projectsLink={<Link to={getRouteProjects()} onClick={resetDraft} data-testid="create-header-back-button" />}
        />
      </AppHeaderStart>
      <AppHeaderEnd>
        <AccountBar />
      </AppHeaderEnd>
    </>
  );
}
